/* Hocenlub PDP JS — from source, data fed via window.AERODISC_CONFIG. Guarded. */
(function(){if(window.__adPdpInit)return;window.__adPdpInit=true;
// ── Config Data ──────────────────────────────────────────────────────────────

const COLORS = (window.AERODISC_CONFIG && window.AERODISC_CONFIG.colors && window.AERODISC_CONFIG.colors.length) ? window.AERODISC_CONFIG.colors : [
  {
    id: "0Q",
    name: "Chalk",
    type: "Solid",
    hex: "#E4E0D5",
    metallic: false,
    price: 0,
    img: "public/t-white.jpeg"
  },
  {
    id: "G1",
    name: "Guards Red",
    type: "Solid",
    hex: "#B8001F",
    metallic: false,
    price: 0,
    img: "public/t-red.jpeg"
  },
  {
    id: "45",
    name: "Gentian Blue",
    type: "Metallic",
    hex: "#1C3D6E",
    metallic: true,
    price: 820,
    img: "public/t-blue.jpeg"
  },
  {
    id: "A1",
    name: "Black",
    type: "Solid",
    hex: "#0A0A0A",
    metallic: false,
    price: 0
  }
];

const WHEELS = (window.AERODISC_CONFIG && window.AERODISC_CONFIG.wheels && window.AERODISC_CONFIG.wheels.length) ? window.AERODISC_CONFIG.wheels : [
  { id: "w1",  sku: "HCN-1001", name: "Crimson Vortex",  size: 20, price:  299, thumb: "public/wheel-1.png" },
  { id: "w2",  sku: "HCN-1002", name: "Stealth Rotor",   size: 20, price:  299, thumb: "public/wheel-2.png" },
  { id: "w3",  sku: "HCN-1003", name: "Arctic Camo",     size: 20, price:  329, thumb: "public/wheel-3.png" },
  { id: "w4",  sku: "HCN-1004", name: "Hex Carbon",      size: 21, price:  349, thumb: "public/wheel-4.png" },
  { id: "w5",  sku: "HCN-1005", name: "Solar Flare",     size: 21, price:  349, thumb: "public/wheel-5.png" },
  { id: "w6",  sku: "HCN-1006", name: "Crimson Web",     size: 21, price:  369, thumb: "public/wheel-6.png" },
  { id: "w7",  sku: "HCN-1007", name: "Onyx Stealth",    size: 22, price:  389, thumb: "public/wheel-7.png" },
  { id: "w8",  sku: "HCN-1008", name: "Apex Striker",    size: 22, price:  389, thumb: "public/wheel-8.png" },
  { id: "w9",  sku: "HCN-1009", name: "Inferno Halo",    size: 22, price:  399, thumb: "public/wheel-9.png" },
  { id: "w10", sku: "HCN-1010", name: "Nebula Drift",    size: 20, price:  299, thumb: "public/wheel-10.png" },
  { id: "w11", sku: "HCN-1011", name: "Polar Vortex",    size: 20, price:  299, thumb: "public/wheel-11.png" },
  { id: "w12", sku: "HCN-1012", name: "Lunar Halo",      size: 20, price:  309, thumb: "public/wheel-12.png" },
  { id: "w13", sku: "HCN-1013", name: "Magnetic Pulse",  size: 20, price:  319, thumb: "public/wheel-13.png" },
  { id: "w14", sku: "HCN-1014", name: "Cosmic Veil",     size: 21, price:  329, thumb: "public/wheel-14.png" },
  { id: "w15", sku: "HCN-1015", name: "Iron Lattice",    size: 21, price:  339, thumb: "public/wheel-15.png" },
  { id: "w16", sku: "HCN-1016", name: "Ember Flux",      size: 21, price:  349, thumb: "public/wheel-16.png" },
  { id: "w17", sku: "HCN-1017", name: "Quantum Mesh",    size: 21, price:  349, thumb: "public/wheel-17.png" },
  { id: "w18", sku: "HCN-1018", name: "Shadow Cipher",   size: 21, price:  359, thumb: "public/wheel-18.png" },
  { id: "w19", sku: "HCN-1019", name: "Phantom Edge",    size: 21, price:  359, thumb: "public/wheel-19.png" },
  { id: "w20", sku: "HCN-1020", name: "Aurora Spin",     size: 22, price:  369, thumb: "public/wheel-20.png" },
  { id: "w21", sku: "HCN-1021", name: "Titanium Reef",   size: 22, price:  369, thumb: "public/wheel-21.png" },
  { id: "w22", sku: "HCN-1022", name: "Velocity Forge",  size: 22, price:  379, thumb: "public/wheel-22.png" },
  { id: "w23", sku: "HCN-1023", name: "Eclipse Halo",    size: 22, price:  379, thumb: "public/wheel-23.png" },
  { id: "w24", sku: "HCN-1024", name: "Crimson Tide",    size: 22, price:  389, thumb: "public/wheel-24.png" },
  { id: "w25", sku: "HCN-1025", name: "Obsidian Wave",   size: 22, price:  389, thumb: "public/wheel-25.png" },
  { id: "w26", sku: "HCN-1026", name: "Galactic Spire",  size: 22, price:  399, thumb: "public/wheel-26.png" },
  { id: "w27", sku: "HCN-1027", name: "Solar Eclipse",   size: 22, price:  399, thumb: "public/wheel-27.png" },
  { id: "w28", sku: "HCN-1028", name: "Tempest Coil",    size: 22, price:  409, thumb: "public/wheel-28.png" },
  { id: "w29", sku: "HCN-1029", name: "Midnight Forge",  size: 22, price:  419, thumb: "public/wheel-29.png" },
  { id: "w30", sku: "HCN-1030", name: "Apex Reactor",    size: 22, price:  429, thumb: "public/wheel-30.png" }
];

// ── State ────────────────────────────────────────────────────────────────────

const SIDE_PERSP_ID = "ext-low-side-left";

const PRODUCT = (window.AERODISC_CONFIG && window.AERODISC_CONFIG.product) || {};

const state = {
  color: (COLORS[0] && COLORS[0].id) || "0Q",
  variantId: (COLORS[0] && COLORS[0].variantId) || null,
  wheel: (WHEELS[0] && WHEELS[0].id) || null,
  finish: "Glossy",
  size: 20,
  persp: SIDE_PERSP_ID
};

function money(cents) {
  if (cents == null) return "";
  const d = cents / 100;
  return "$" + (Number.isInteger(d) ? d.toLocaleString() : d.toFixed(2));
}

// Preloaded Image cache
const imgCache = {};

// ── DOM refs ─────────────────────────────────────────────────────────────────

const carStage = document.getElementById("carStage");
const stageLoading = document.getElementById("stageLoading");
const colorGrid = document.getElementById("colorGrid");
const wheelGrid = document.getElementById("wheelGrid");
const configSummary = document.getElementById("configSummary");

// ── Build color grid ─────────────────────────────────────────────────────────

if (colorGrid) COLORS.forEach(c => {
  const opt = document.createElement("div");
  opt.className = "color-option" + (c.id === state.color ? " active" : "");
  opt.dataset.id = c.id;
  opt.innerHTML = `
    <div class="color-swatch${c.metallic ? " metallic" : ""}" style="background:${c.hex}"></div>
    <div class="color-info">
      <div class="color-name">${c.name}</div>
    </div>
    <div class="color-check"><div class="color-check-dot"></div></div>
  `;
  opt.addEventListener("click", () => {
    state.color = c.id;
    state.variantId = c.variantId || state.variantId;
    document.querySelectorAll(".color-option").forEach(el => el.classList.remove("active"));
    opt.classList.add("active");
    showCar();
    renderSummary();
  });
  colorGrid.appendChild(opt);
});

// ── Build wheel grid ─────────────────────────────────────────────────────────

// Mobile: bring the car stage back into view (scroll-padding-top in the CSS
// keeps it clear of the sticky nav). Falls back for old Safari without
// ScrollIntoViewOptions support.
function scrollToStage() {
  const stage = document.querySelector(".stage") || carStage;
  if (!stage) return;
  try {
    stage.scrollIntoView({ behavior: "smooth", block: "start" });
  } catch (e) {
    stage.scrollIntoView(true);
  }
}

function renderWheelGrid() {
  if (!wheelGrid) return;
  wheelGrid.innerHTML = "";
  WHEELS.forEach(w => {
    const opt = document.createElement("div");
    opt.className = "wheel-option" + (w.id === state.wheel ? " active" : "");
    opt.dataset.id = w.id;
    opt.title = `${w.name}${w.price > 0 ? ` · $${w.price.toLocaleString()}` : ""}`;

    opt.innerHTML = `
      <img class="wheel-thumb" src="${w.thumb}" alt="${w.name}" loading="lazy" decoding="async" onerror="this.style.opacity='0'">
    `;

    opt.addEventListener("click", () => {
      state.wheel = w.id;
      document.querySelectorAll(".wheel-option").forEach(el => el.classList.remove("active"));
      opt.classList.add("active");
      // Scroll FIRST so an error in any render call below can't cancel it.
      // 860px matches the breakpoint where the panel stacks under the stage.
      if (window.matchMedia("(max-width: 860px)").matches) scrollToStage();
      renderWheelLabel();
      showCar();
      renderSummary();
      updateSpinWheel();
    });
    wheelGrid.appendChild(opt);
  });
}
renderWheelGrid();

// ── Finish selector (Glossy / Matte) + native product-form sync ───────────────
const elVariant = document.getElementById("adVariantId");
const elDesign  = document.getElementById("adPropDesign");
const elFinish  = document.getElementById("adPropFinish");
const elSku     = document.getElementById("adPropSku");

function syncForm() {
  const w = WHEELS.find(x => x.id === state.wheel);
  if (elVariant && state.variantId) elVariant.value = state.variantId;
  if (elDesign) elDesign.value = w ? w.name : "";
  if (elSku)    elSku.value    = w ? w.sku  : "";
  if (elFinish) elFinish.value = state.finish;
}

document.querySelectorAll("#finishGrid .finish-option").forEach(btn => {
  btn.addEventListener("click", () => {
    state.finish = btn.dataset.finish;
    document.querySelectorAll("#finishGrid .finish-option").forEach(b => b.classList.remove("active"));
    btn.classList.add("active");
    syncForm();
    renderSummary();
  });
});

// Size selector (optional — removed on car product templates)
const sizeSelect = document.getElementById("sizeSelect");
if (sizeSelect) {
  sizeSelect.value = String(state.size);
  sizeSelect.addEventListener("change", () => {
    state.size = parseInt(sizeSelect.value, 10);
  });
}

// Model selector (optional — the product IS the car, so usually absent)
const modelSelect = document.getElementById("modelSelect");
if (modelSelect) {
  state.model = modelSelect.value;
  modelSelect.addEventListener("change", () => {
    state.model = modelSelect.value;
  });
}

const wheelSelectedLabel = document.getElementById("wheelSelectedLabel");
function renderWheelLabel() {
  if (!wheelSelectedLabel) return;
  const w = WHEELS.find(x => x.id === state.wheel);
  if (!w) {
    wheelSelectedLabel.innerHTML = `<span class="price">Select a wheel</span>`;
    return;
  }
  wheelSelectedLabel.innerHTML = `
    ${w.name}<span class="price">${w.price > 0 ? `+$${w.price.toLocaleString()}` : "Included"}</span>
    <div class="sku">SKU · ${w.sku}</div>
  `;
}
renderWheelLabel();


// ── Car image display ─────────────────────────────────────────────────────────

function cacheKey(color, wheel, persp) {
  return `${color}_${wheel}_${persp}`;
}

function getOrCreateImg(color, wheel, persp) {
  if (!carStage) return null;
  const key = cacheKey(color, wheel, persp);
  if (imgCache[key]) return imgCache[key];

  const colorObj = COLORS.find(c => c.id === color);
  const img = document.createElement("img");
  img.className = "car-img";
  img.alt = `Hocenlub - ${color} - ${wheel}`;
  if (!colorObj || !colorObj.img) {
    // No local image for this color (e.g. Black, awaiting asset) — leave stage empty.
    img.dataset.failed = "1";
    carStage.appendChild(img);
    imgCache[key] = img;
    return img;
  }
  img.src = colorObj.img;

  img.onload = () => {
    // if this is the current config, show it
    if (key === cacheKey(state.color, state.wheel, state.persp)) {
      revealCurrent(key);
    }
  };

  img.onerror = () => {
    img.dataset.failed = "1";
    if (key === cacheKey(state.color, state.wheel, state.persp)) {
      stageLoading.classList.remove("visible");
    }
  };

  carStage.appendChild(img);
  imgCache[key] = img;
  return img;
}

let introActive = true;

function revealCurrent(key) {
  if (introActive) return;
  // Hide all
  Object.entries(imgCache).forEach(([k, img]) => {
    img.classList.remove("active");
  });
  // Show current
  if (imgCache[key]) {
    imgCache[key].classList.add("active");
  }
  stageLoading.classList.remove("visible");
  if (state.wheel) updateSpinWheel();
}

function showCar() {
  if (!carStage) return;
  const { color, wheel, persp } = state;
  const key = cacheKey(color, wheel, persp);

  const img = getOrCreateImg(color, wheel, persp);

  if (img.complete && !img.dataset.failed) {
    revealCurrent(key);
  } else {
    // show loader, wait for onload
    stageLoading.classList.add("visible");
    // hide others immediately
    Object.entries(imgCache).forEach(([k, i]) => {
      if (k !== key) i.classList.remove("active");
    });
  }

  // Preload adjacent combos
  preloadNeighbors(color, wheel, persp);
}

function preloadNeighbors(color, wheel, persp) {
  // The car image only varies by color, so preloading every color×wheel combo
  // (4×90 = 360 nodes) was pure DOM churn during the intro. Preload just the
  // other colors for the current wheel; other combos are created on demand and
  // hit the browser cache instantly.
  COLORS.forEach(c => {
    getOrCreateImg(c.id, wheel, persp);
  });
}

// ── Summary ──────────────────────────────────────────────────────────────────

function renderSummary() {
  if (!configSummary) return;
  const wheel = WHEELS.find(w => w.id === state.wheel);
  const price = PRODUCT.price || 0;
  const cmp = PRODUCT.compareAt || 0;
  const priceHtml = price
    ? `${money(price)}${cmp > price ? ` <s style="opacity:.45;font-weight:400">${money(cmp)}</s>` : ""}`
    : (wheel ? "$" + (wheel.price || 0).toLocaleString() : "—");

  configSummary.innerHTML = `
    <div class="summary-total">
      <span class="summary-total-label">Total</span>
      <span class="summary-total-price">${priceHtml}</span>
    </div>
    <div class="summary-line" style="font-size:13px;opacity:${wheel ? ".75" : ".5"};margin-top:4px">
      ${(window.AD_VEHICLE && window.AD_VEHICLE.model) ? window.AD_VEHICLE.model + (window.AD_VEHICLE.size ? " · " + window.AD_VEHICLE.size.replace('"', "″") : "") + (window.AD_VEHICLE.photo ? " · photo ✓" : "") + "<br>" : ""}${wheel ? (window.AD_DESIGN ? window.AD_DESIGN + " · " : "") + wheel.name + (document.getElementById("finishGrid") ? " · " + state.finish : "") : "Select a design below"}
    </div>
  `;
  syncForm();
}
window.__adRenderSummary = renderSummary;

// ── Init ──────────────────────────────────────────────────────────────────────

renderSummary();
showCar();

// ── Add to cart ───────────────────────────────────────────────────────────────

const btnPrimary   = document.getElementById("adAddBtn") || document.querySelector(".panel-cta .btn-primary");
const btnSecondary = document.querySelector(".panel-cta .btn-secondary");

async function addToCart() {
  if (!state.variantId) return; // not a real product page (preview/preset)

  // Vehicle model + size (+ wheel photo when the photo row exists) are required
  const vehSel = document.getElementById("vehModel");
  const vehPhotoMissing = window.AD_VEH_PHOTO_REQUIRED &&
    (!window.AD_VEHICLE || !window.AD_VEHICLE.photo);
  if (vehSel && window.AD_VEH_REQUIRED &&
      (!window.AD_VEHICLE || !window.AD_VEHICLE.model || !window.AD_VEHICLE.size || vehPhotoMissing)) {
    const vehBlock = vehSel.closest(".veh-section") || vehSel;
    vehBlock.scrollIntoView({ behavior: "smooth", block: "center" });
    vehBlock.classList.add("veh-attn");
    const phEl = document.getElementById("vehPh");
    if (phEl && window.AD_VEHICLE && window.AD_VEHICLE.model && window.AD_VEHICLE.size && vehPhotoMissing) {
      phEl.classList.add("veh-ph--err");
    }
    setTimeout(() => {
      vehBlock.classList.remove("veh-attn");
      if (phEl) phEl.classList.remove("veh-ph--err");
    }, 1600);
    return;
  }

  const w = WHEELS.find(x => x.id === state.wheel);
  if (!w) {
    if (wheelGrid) wheelGrid.scrollIntoView({ behavior: "smooth", block: "center" });
    if (wheelSelectedLabel) {
      wheelSelectedLabel.style.color = "#B8001F";
      setTimeout(() => { wheelSelectedLabel.style.color = ""; }, 1200);
    }
    return;
  }

  const orig = btnPrimary.textContent;
  btnPrimary.disabled = true;
  btnPrimary.textContent = "Adding…";

  const cartDrawer = document.querySelector("cart-drawer");
  // Hidden steps still ship their defaults, but under "_"-prefixed names so cart/checkout don't show them
  const props = { "Wheel Design": w.name, "_SKU": w.sku };
  props[document.getElementById("finishGrid") ? "Finish" : "_Finish"] = state.finish;
  // Design (Hocenlub/Cyberdisc) + its bundled lock — set by the section's inline script
  const designVisible = !!document.getElementById("adgRow");
  const elDiscDesign = document.getElementById("adPropDiscDesign");
  const elMounting   = document.getElementById("adPropMounting");
  if (elDiscDesign && elDiscDesign.value) props[designVisible ? "Design" : "_Design"]     = elDiscDesign.value;
  if (elMounting   && elMounting.value)   props[designVisible ? "Mounting" : "_Mounting"] = elMounting.value;
  if (window.AD_VEHICLE && window.AD_VEHICLE.model) {
    props["Vehicle Model"] = window.AD_VEHICLE.model;
    if (window.AD_VEHICLE.size) props["Wheel Size"] = window.AD_VEHICLE.size;
  }

  // Upload the fitment photo first; its URL travels on the order as a hidden property.
  // An upload failure must not lose the sale — flag it for manual follow-up instead.
  if (window.AD_VEHICLE && window.AD_VEHICLE.photo && window.AD_FITMENT_ENDPOINT) {
    btnPrimary.textContent = "Uploading photo…";
    try {
      const fd = new FormData();
      fd.append("wheel", window.AD_VEHICLE.photo);
      fd.append("car", window.AD_VEHICLE.model + " " + (window.AD_VEHICLE.size || ""));
      fd.append("source", "pdp");
      const upRes = await fetch(window.AD_FITMENT_ENDPOINT, { method: "POST", body: fd });
      const upData = await upRes.json();
      props["_Wheel Photo"] = (upRes.ok && upData.ok && upData.photos && upData.photos.wheel)
        ? upData.photos.wheel
        : "UPLOAD FAILED — request photo from customer";
    } catch (e) {
      props["_Wheel Photo"] = "UPLOAD FAILED — request photo from customer";
    }
    btnPrimary.textContent = "Adding…";
  }
  const body = {
    items: [{
      id: state.variantId,
      quantity: 1,
      properties: props
    }]
  };
  if (cartDrawer && typeof cartDrawer.getSectionsToRender === "function") {
    body.sections = cartDrawer.getSectionsToRender().map(s => s.id).join(",");
    body.sections_url = window.location.pathname;
  }

  try {
    const res = await fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json", "Accept": "application/json" },
      body: JSON.stringify(body)
    });
    const data = await res.json();
    if (!res.ok) throw new Error((data && data.description) || "Add failed");

    if (cartDrawer && data.sections) {
      cartDrawer.renderContents(data);
      btnPrimary.textContent = orig;
    } else {
      window.location = "/cart";
      return;
    }
  } catch (e) {
    btnPrimary.textContent = "Try again";
    setTimeout(() => { btnPrimary.textContent = orig; }, 1500);
  } finally {
    btnPrimary.disabled = false;
  }
}

if (btnPrimary)   btnPrimary.addEventListener("click", addToCart);
if (btnSecondary) btnSecondary.addEventListener("click", () => { window.location = "/cart"; });

// ── Intro video → fade out → show car ────────────────────────────────────────

(function () {
  const video = document.getElementById("introVideo");
  if (!video) return;

  function endIntro() {
    if (!introActive) return;
    introActive = false;
    video.classList.add("fade-out");   // 视频淡出
    video.addEventListener("transitionend", () => {
      video.style.display = "none";
    }, { once: true });
    showCar();                          // 视频结束直接显示车图（已无 last-frame）
  }

  video.addEventListener("ended", endIntro);

  // 视频加载失败 → 直接跳过
  video.addEventListener("error", () => {
    introActive = false;
    video.style.display = "none";
    showCar();
  });

  // The autoplay attribute alone gets deferred in energy-saver / low-battery /
  // background-tab situations, leaving the stage frozen on frame 0. An explicit
  // play() call starts playback in those same situations, so the full intro
  // still runs. A hard rejection (autoplay fully banned) skips to the car. No
  // time-based skip here — the animation is never cut short.
  function kick() {
    const p = video.play();
    if (p && p.catch) p.catch(() => endIntro());
  }
  kick();
  document.addEventListener("visibilitychange", () => {
    if (document.visibilityState === "visible" && introActive && video.paused && !video.ended) kick();
  });

  // Fallback: if the clip never fires 'ended' (editor / slow load), reveal anyway
  setTimeout(endIntro, 8000);
})();

// Preload the other color images for the side view — AFTER the intro video is
// done (was 1.5s × all color×wheel combos: a mid-intro burst that made the
// animation stutter).
setTimeout(() => {
  COLORS.forEach(c => {
    getOrCreateImg(c.id, state.wheel, SIDE_PERSP_ID);
  });
}, 6500);

// ── Wheel Spin Mode ───────────────────────────────────────────────────────────

const wheelOverlayR  = document.getElementById("wheelOverlayRear");
const wheelOverlayF  = document.getElementById("wheelOverlayFront");
const stageEl        = document.querySelector(".stage");

// ── Wheel-cover overlay placement (merchant-configurable, % of stage) ─────────
// Positions come from the section settings via AERODISC_CONFIG.stage.
const _S = (window.AERODISC_CONFIG && window.AERODISC_CONFIG.stage) || {};
// Values arrive as strings (text settings allow decimals) or numbers — coerce to float.
function _num(v, fallback) {
  const n = parseFloat(v);
  return isNaN(n) ? fallback : n;
}
const SPOS = {
  frontX: _num(_S.frontX, 31),
  frontY: _num(_S.frontY, 57),
  frontD: _num(_S.frontD, 14),
  rearX:  _num(_S.rearX, 68),
  rearY:  _num(_S.rearY, 57),
  rearD:  _num(_S.rearD, 14)
};

// Place an overlay at an IMAGE-relative %, mapped into the image's rendered box.
// rw/rh = rendered image size (px), ox/oy = its top-left offset inside the stage.
// Everything is relative to the rendered image, so positions hold at any container size.
function placeOverlay(el, xPct, yPct, dPct, rw, rh, ox, oy) {
  const d = (dPct / 100) * rh;
  el.style.width  = d + "px";
  el.style.height = d + "px";
  el.style.left   = (ox + (xPct / 100) * rw - d / 2) + "px";
  el.style.top    = (oy + (yPct / 100) * rh - d / 2) + "px";
}

// The currently displayed car image (falls back to any car-img in the stage).
function activeCarImg() {
  return carStage.querySelector(".car-img.active") || carStage.querySelector(".car-img");
}

function positionWheelOverlays() {
  const cw = stageEl.offsetWidth;
  const ch = stageEl.offsetHeight;
  const img = activeCarImg();
  // Natural dims of the active car image; fall back to the container if not loaded yet.
  const iw = (img && img.naturalWidth)  || cw;
  const ih = (img && img.naturalHeight) || ch;

  // Reproduce object-fit: cover — scale to fill, center, crop overflow.
  const scale = Math.max(cw / iw, ch / ih);
  const rw = iw * scale;          // rendered image width  (px)
  const rh = ih * scale;          // rendered image height (px)
  const ox = (cw - rw) / 2;       // image top-left X inside stage (≤ 0 for cover)
  const oy = (ch - rh) / 2;       // image top-left Y inside stage

  placeOverlay(wheelOverlayR, SPOS.rearX,  SPOS.rearY,  SPOS.rearD,  rw, rh, ox, oy);
  placeOverlay(wheelOverlayF, SPOS.frontX, SPOS.frontY, SPOS.frontD, rw, rh, ox, oy);
}

// Live-tune in the theme editor: re-read positions when the section reloads.
document.addEventListener("shopify:section:load", () => {
  const s = window.AERODISC_CONFIG && window.AERODISC_CONFIG.stage;
  if (!s) return;
  ["frontX","frontY","frontD","rearX","rearY","rearD"].forEach(k => {
    if (s[k] != null) SPOS[k] = _num(s[k], SPOS[k]);
  });
  if (typeof updateSpinWheel === "function") updateSpinWheel();
});

function updateSpinWheel() {
  const activeWheel = WHEELS.find(w => w.id === state.wheel);
  if (!activeWheel) {
    wheelOverlayR.classList.remove("spinning");
    wheelOverlayF.classList.remove("visible");
    wheelOverlayR.src = "";
    wheelOverlayF.src = "";
    return;
  }
  // Stage overlays need the 600px art; grid thumbs are now a smaller rendition.
  const artSrc = activeWheel.art || activeWheel.thumb;
  wheelOverlayR.src = artSrc;
  wheelOverlayF.src = artSrc;
  positionWheelOverlays();
  wheelOverlayR.classList.add("spinning");
  wheelOverlayF.classList.add("visible");
}

// Spin activates when a wheel is selected; switching updates the overlay source
if (wheelGrid) wheelGrid.addEventListener("click", updateSpinWheel);

// Reposition on resize (only relevant once a wheel is chosen)
window.addEventListener("resize", () => {
  if (state.wheel) positionWheelOverlays();
});

// ── First-screen scroll routing ─────────────────────────────────────────────
// When the user is on the first screen and the wheel is over the LEFT stage,
// forward the scroll to the RIGHT panel until the panel finishes; only then
// allow the page to advance below. Wheel events that originate over the panel
// itself are left to the browser (native scrolling + overscroll chaining
// already does the right thing there).
(function () {
  const stage = document.querySelector(".stage");
  const panel = document.querySelector(".panel");
  if (!stage || !panel) return;

  stage.addEventListener("wheel", (e) => {
    // Once the page has scrolled past the first viewport, stop hijacking.
    if (window.scrollY > 0) return;

    const atBottom = panel.scrollTop + panel.clientHeight >= panel.scrollHeight - 1;
    const atTop    = panel.scrollTop <= 0;

    if (e.deltaY > 0 && !atBottom) {
      e.preventDefault();
      panel.scrollTop += e.deltaY;
    } else if (e.deltaY < 0 && !atTop) {
      e.preventDefault();
      panel.scrollTop += e.deltaY;
    }
    // else: let the body scroll naturally (advance to the next section /
    // already at the very top with panel also at top).
  }, { passive: false });
})();


// ── Section nav (sticky) ────────────────────────────────────────────────────
(function () {
  const nav = document.getElementById("sectionNav");
  let navLinks = Array.from(document.querySelectorAll(".nav-link"));
  const navCta = document.getElementById("navCta");
  if (!nav || !navLinks.length) return;

  // Adapt to hidden sections: a disabled section renders nothing, so hide its
  // link. sec-faq falls back to the standalone FAQ section (id "faq") when the
  // PDP FAQ was swapped out for it.
  const FALLBACK = { "sec-faq": "faq" };
  navLinks = navLinks.filter(link => {
    let id = link.dataset.target;
    if (!document.getElementById(id) && FALLBACK[id] && document.getElementById(FALLBACK[id])) {
      id = FALLBACK[id];
      link.dataset.target = id;
      link.setAttribute("href", "#" + id);
    }
    if (!document.getElementById(id)) { link.style.display = "none"; return false; }
    return true;
  });
  if (!navLinks.length) return;

  navLinks.forEach(link => {
    link.addEventListener("click", (e) => {
      e.preventDefault();
      const id = link.dataset.target;
      const target = document.getElementById(id);
      if (!target) return;
      const offset = nav.offsetHeight;
      const y = target.getBoundingClientRect().top + window.pageYOffset - offset + 1;
      window.scrollTo({ top: y, behavior: "smooth" });
    });
  });

  if (navCta) {
    navCta.addEventListener("click", () => {
      window.scrollTo({ top: 0, behavior: "smooth" });
    });
  }

  const sections = navLinks
    .map(l => document.getElementById(l.dataset.target))
    .filter(Boolean);
  const io = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = entry.target.id;
        navLinks.forEach(l => l.classList.toggle("active", l.dataset.target === id));
      }
    });
  }, { rootMargin: "-40% 0px -55% 0px", threshold: 0 });
  sections.forEach(s => io.observe(s));
})();

// ── FAQ accordion ───────────────────────────────────────────────────────────
document.querySelectorAll('#faqList .faq-item').forEach(item => {
  const q = item.querySelector('.faq-q');
  const a = item.querySelector('.faq-a');
  if (!q || !a) return;
  q.addEventListener('click', () => {
    const isOpen = item.classList.toggle('open');
    a.style.maxHeight = isOpen ? a.scrollHeight + 'px' : '0';
  });
});

// ── Watch tab switcher + click-to-load YouTube facade ───────────────────────
(function () {
  const tabs   = document.querySelectorAll('.watch-tab');
  const panels = document.querySelectorAll('.watch-frame');
  const caps   = document.querySelectorAll('.watch-cap');
  const stage  = document.querySelector('.watch-stage');

  /* The player ships as a facade — a poster plus a play badge — and the
     YouTube iframe is only built on click. A page view therefore costs no
     third-party request, and an embed that can't load (blocked, offline,
     rate-limited) can never paint a broken frame before anyone asks for it. */
  function playFacade(btn) {
    if (btn.dataset.loaded) return;
    const id = btn.dataset.yt;
    if (!id) return;
    const start = btn.dataset.start;
    const frame = document.createElement('iframe');
    frame.src = 'https://www.youtube.com/embed/' + encodeURIComponent(id) +
      '?autoplay=1&rel=0&playsinline=1' + (start ? '&start=' + encodeURIComponent(start) : '');
    frame.title = btn.dataset.title || 'Hocenlub video';
    frame.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    btn.dataset.loaded = '1';
    btn.hidden = true;
    btn.parentElement.appendChild(frame);
  }

  /* Switching tabs tears the iframe down so a hidden panel can't keep playing
     audio, and brings that panel's poster back. */
  function resetFacade(panel) {
    const frame = panel.querySelector('iframe');
    const btn = panel.querySelector('.watch-facade');
    if (!frame || !btn) return;
    frame.remove();
    btn.hidden = false;
    delete btn.dataset.loaded;
  }

  if (stage) {
    stage.addEventListener('click', (e) => {
      const btn = e.target.closest('.watch-facade');
      if (btn) playFacade(btn);
    });
  }

  if (!tabs.length) return;
  tabs.forEach(tab => {
    tab.addEventListener('click', () => {
      const key = tab.dataset.watch;
      tabs.forEach(t => t.classList.toggle('active', t === tab));
      panels.forEach(p => {
        const on = p.dataset.watchPanel === key;
        if (!on) resetFacade(p);
        p.classList.toggle('active', on);
      });
      caps.forEach(c => { c.hidden = (c.dataset.watchCap !== key); });
    });
  });
})();

// ── PDP reveal on scroll ────────────────────────────────────────────────────
(function () {
  const els = document.querySelectorAll('.reveal');
  if (!els.length) return;
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        e.target.classList.add('in');
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(el => io.observe(el));
})();

// ── Lifestyle sticky scrollytelling: crossfade pinned image to active step ──
(function () {
  const root = document.getElementById('lifeScrolly');
  if (!root) return;
  const imgs  = root.querySelectorAll('.ss-img');
  const steps = root.querySelectorAll('.ss-step');
  if (!steps.length) return;
  const setActive = (i) => imgs.forEach(im => im.classList.toggle('active', +im.dataset.i === i));
  // A step becomes active when it crosses the vertical centre of the viewport.
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) setActive(+e.target.dataset.i); });
  }, { rootMargin: '-45% 0px -45% 0px', threshold: 0 });
  steps.forEach(s => io.observe(s));
})();

// ── Stagger reveal for repeating content blocks ─────────────────────────────
(function () {
  const SELECTOR = [
    '.bento-tile', '.box-item', '.tl-item', '.faq-item',
    '.ugc-card', '.rvw-card', '.reco-card'
  ].join(',');
  const items = Array.from(document.querySelectorAll(SELECTOR))
    .filter(el => !el.closest('.stage') && !el.classList.contains('reveal'));
  if (!items.length) return;

  // Stagger delay by sibling position within each parent (capped).
  const seen = new Map();
  items.forEach(el => {
    const p = el.parentElement;
    const i = seen.get(p) || 0;
    seen.set(p, i + 1);
    el.dataset.rvDelay = Math.min(i, 6) * 70;
    el.classList.add('rv');
  });

  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (!e.isIntersecting) return;
      const el = e.target;
      io.unobserve(el);
      // JS-timed stagger keeps inline transition-delay off the element, so it
      // never leaks into the card's own hover transitions.
      setTimeout(() => el.classList.add('in'), +el.dataset.rvDelay || 0);
    });
  }, { threshold: 0.12 });
  items.forEach(el => io.observe(el));
})();

// ── Feature counter (count-up on scroll) ────────────────────────────────────
(function () {
  const counters = document.querySelectorAll('.count');
  if (!counters.length) return;
  const easeOutCubic = t => 1 - Math.pow(1 - t, 3);
  const animate = (el) => {
    const from = parseFloat(el.dataset.from || '0');
    const to = parseFloat(el.dataset.to || '0');
    const decimals = parseInt(el.dataset.decimals || '0', 10);
    const prefix = el.dataset.prefix || '';
    const suffix = el.dataset.suffix || '';
    const duration = 1400;
    const start = performance.now();
    const tick = (now) => {
      const t = Math.min(1, (now - start) / duration);
      const v = from + (to - from) * easeOutCubic(t);
      el.textContent = prefix + v.toFixed(decimals) + suffix;
      if (t < 1) requestAnimationFrame(tick);
    };
    requestAnimationFrame(tick);
  };
  const io = new IntersectionObserver((entries) => {
    entries.forEach(e => {
      if (e.isIntersecting) {
        animate(e.target);
        io.unobserve(e.target);
      }
    });
  }, { threshold: 0.4 });
  counters.forEach(el => io.observe(el));
})();

// ── Accordion ───────────────────────────────────────────────────────────────
document.querySelectorAll("#accordions .accordion-item").forEach(item => {
  const header = item.querySelector(".accordion-header");
  const body = item.querySelector(".accordion-body");
  header.addEventListener("click", () => {
    const isOpen = item.classList.toggle("open");
    body.style.maxHeight = isOpen ? body.scrollHeight + "px" : "0";
  });
});

// ── Section-nav pin (nav is its own section now; emulate sticky via fixed) ────
(function () {
  var nav = document.getElementById("sectionNav");
  var holder = document.getElementById("sectionNavHolder");
  if (!nav || !holder) return;
  var pinned = false;
  function onScroll() {
    if (!pinned) {
      if (nav.getBoundingClientRect().top <= 0) {
        holder.style.height = nav.offsetHeight + "px";
        nav.classList.add("pinned");
        pinned = true;
      }
    } else if (holder.getBoundingClientRect().top >= 0) {
      // Unpin only when the holder (which keeps the nav's natural slot) is back
      // in view — geometric condition, unlike the old scrollY snapshot which was
      // sampled late and caused a pin/unpin oscillation when scrolling up.
      nav.classList.remove("pinned");
      holder.style.height = "";
      pinned = false;
    }
  }
  window.addEventListener("scroll", onScroll, { passive: true });
  onScroll();
})();

// ── Horizontal card rails: show a scroll-progress bar so users know they can
//    swipe sideways. (Locking to horizontal pan is done in CSS via touch-action.)
(function () {
  var sels = ['.ss-steps', '.heritage-timeline', '.rvw-scroll', '.ugc-track', '.reco-grid'];
  var rails = [];
  sels.forEach(function (s) {
    document.querySelectorAll(s).forEach(function (el) { rails.push(el); });
  });
  if (!rails.length) return;
  rails.forEach(function (rail) {
    var bar = document.createElement('div');
    bar.className = 'hscroll-bar';
    var thumb = document.createElement('span');
    bar.appendChild(thumb);
    rail.parentNode.insertBefore(bar, rail.nextSibling);
    function update() {
      var sw = rail.scrollWidth, cw = rail.clientWidth;
      if (sw <= cw + 2) { bar.classList.remove('is-on'); return; }
      bar.classList.add('is-on');
      var ratio = cw / sw;
      thumb.style.width = (ratio * 100) + '%';
      var max = sw - cw;
      var pos = max > 0 ? rail.scrollLeft / max : 0;
      thumb.style.transform = 'translateX(' + (pos * (1 / ratio - 1) * 100) + '%)';
    }
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    // content/images can change width after load
    window.addEventListener('load', update);
    setTimeout(update, 600);
    update();
  });
})();

})();
